import React, { useEffect } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";
import { getUserToken } from "../../config/user";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../routes/ui/uiRoutes";
import OverlayLoader from "../Common/OverlayLoader";
const UIBody = (props) => {
  const navigate = useNavigate();
  const isLoggedIn = getUserToken();
  useEffect(() => {
    if (isLoggedIn) {
      navigate(uiRoutes.home); // ✅ safe to call here
    }
  }, [isLoggedIn]);

  return (
    <div>

      
      <NavBar/>
      <OverlayLoader show={props.loading} />
      <main class="main-area fix">
        <ToastContainer />
        {props.content}
      </main>
      <Footer />
    </div>
  );
};

export default UIBody;
